"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.dropTarget = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDnd = require("react-dnd");

var _ColumnHeader = _interopRequireDefault(require("./ColumnHeader"));

var _ColumnReorderDropTarget = _interopRequireDefault(require("./ColumnReorderDropTarget"));

var _CwDataGrid = _interopRequireDefault(require("../CwDataGrid.scss"));
/**
 * specifies how to handle drag and drop events
 */


var dropTarget = {
  drop: function drop(props, monitor) {
    var item = monitor.getItem();
    props.handleColumnResize(item.columnKey, monitor.getDifferenceFromInitialOffset().x);
  },
  hover: function hover(props, monitor, component) {
    component.handleHover(monitor.getDifferenceFromInitialOffset());
  }
};
/**
 * Specifies the props to inject into your component via react-dnd.
 */

exports.dropTarget = dropTarget;

function collect(connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
}
/**
 * component
 */


var ColumnHeaderContainer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ColumnHeaderContainer, _React$Component);

  function ColumnHeaderContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ColumnHeaderContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ColumnHeaderContainer).call(this, props));
    _this.offsetNeedsUpdate = true;
    _this.state = {
      hoverOffset: {
        x: 0,
        y: 0
      },
      reorderMode: '',
      resizeMode: false
    };
    _this.handleHover = _this.handleHover.bind((0, _assertThisInitialized2.default)(_this));
    _this.setReorderMode = _this.setReorderMode.bind((0, _assertThisInitialized2.default)(_this));
    _this.setResizeMode = _this.setResizeMode.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ColumnHeaderContainer, [{
    key: "setResizeMode",
    value: function setResizeMode(state) {
      this.setState({
        resizeMode: state
      });
    }
  }, {
    key: "setReorderMode",
    value: function setReorderMode(state) {
      this.setState({
        reorderMode: state
      });
    }
  }, {
    key: "handleHover",
    value: function handleHover(offset) {
      var _this2 = this;

      if (this.offsetNeedsUpdate) {
        this.offsetNeedsUpdate = false;
        this.setState({
          hoverOffset: offset
        });
        window.setTimeout(function () {
          _this2.offsetNeedsUpdate = true;
        }, 10);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return this.props.connectDropTarget(_react.default.createElement("div", {
        ref: function ref(c) {
          _this3.headerViewport = c;
        },
        className: _CwDataGrid.default.headerViewport,
        onScroll: function onScroll() {
          if (_this3.headerViewport.scrollLeft > 0) {
            _this3.props.onScroll(_this3.headerViewport.scrollLeft);

            _this3.headerViewport.scrollLeft = 0;
          }
        }
      }, _react.default.createElement("div", {
        className: _CwDataGrid.default.headerCanvas,
        style: {
          left: -this.props.scrollLeft
        }
      }, this.props.columnDefs.filter(function (col) {
        return !_this3.props.disabledColumns.includes(col.key);
      }).map(function (col) {
        return _react.default.createElement("span", {
          key: col.key,
          "data-cwid": "".concat(_this3.props.cwId, "_column_header_container_").concat(col.key),
          style: {
            position: 'relative'
          }
        }, _react.default.createElement(_ColumnHeader.default, {
          column: col,
          cwId: _this3.props.cwId,
          clearFilterImage: _this3.props.clearFilterImage,
          filterValue: _this3.props.filterValues[col.key],
          onFilterChange: function onFilterChange(value) {
            return _this3.props.onColumnFilterChange(col, value);
          },
          onComboBoxTextChange: function onComboBoxTextChange(value) {
            return _this3.props.onColumnComboBoxTextChange(col, value);
          },
          onDateFilterClick: _this3.props.onDateFilterClick,
          hasFilterTypes: _this3.props.hasFilterTypes,
          resizeHoverOffset: _this3.state.hoverOffset,
          sortCol: _this3.props.sortCol,
          sortReverse: _this3.props.sortReverse,
          setSortCol: _this3.props.setSortCol,
          sortArrowImage: _this3.props.sortArrowImage,
          sortArrowImageReverse: _this3.props.sortArrowImageReverse,
          setReorderMode: _this3.setReorderMode,
          setResizeMode: _this3.setResizeMode
        }), _this3.props.allowColumnReordering && _this3.state.reorderMode !== '' && _this3.state.reorderMode !== col.key && _react.default.createElement("span", null, _react.default.createElement(_ColumnReorderDropTarget.default, {
          columnKey: col.key,
          hasFilterTypes: _this3.props.hasFilterTypes,
          style: {
            width: col.width / 2
          },
          handleColumnReorder: _this3.props.handleColumnReorder
        }), _react.default.createElement(_ColumnReorderDropTarget.default, {
          columnKey: col.key,
          hasFilterTypes: _this3.props.hasFilterTypes,
          style: {
            width: col.width / 2
          },
          handleColumnReorder: _this3.props.handleColumnReorder,
          rightSide: true
        })));
      }))));
    }
  }]);
  return ColumnHeaderContainer;
}(_react.default.Component);

ColumnHeaderContainer.propTypes = {
  cwId: _propTypes.default.string.isRequired,
  columnDefs: _propTypes.default.array.isRequired,
  allowColumnReordering: _propTypes.default.bool,
  clearFilterImage: _propTypes.default.string,
  disabledColumns: _propTypes.default.array.isRequired,
  filterValues: _propTypes.default.object,
  hasFilterTypes: _propTypes.default.bool,
  scrollLeft: _propTypes.default.number,
  sortCol: _propTypes.default.string,
  sortReverse: _propTypes.default.bool,
  sortArrowImage: _propTypes.default.string,
  sortArrowImageReverse: _propTypes.default.string,
  handleColumnReorder: _propTypes.default.func,
  handleColumnResize: _propTypes.default.func,
  // eslint-disable-line react/no-unused-prop-types
  onColumnComboBoxTextChange: _propTypes.default.func,
  onColumnFilterChange: _propTypes.default.func,
  onDateFilterClick: _propTypes.default.func,
  onScroll: _propTypes.default.func.isRequired,
  setSortCol: _propTypes.default.func,
  connectDropTarget: _propTypes.default.func.isRequired
};
ColumnHeaderContainer.defaultProps = {
  allowColumnReordering: false,
  clearFilterImage: '',
  filterValues: {},
  hasFilterTypes: false,
  scrollLeft: 0,
  sortCol: '',
  sortReverse: false,
  sortArrowImage: '',
  sortArrowImageReverse: '',
  onColumnComboBoxTextChange: function onColumnComboBoxTextChange() {},
  onColumnFilterChange: function onColumnFilterChange() {},
  onDateFilterClick: function onDateFilterClick() {},
  handleColumnReorder: function handleColumnReorder() {},
  handleColumnResize: function handleColumnResize() {},
  setSortCol: function setSortCol() {}
};

var _default = (0, _reactDnd.DropTarget)('ColumnResizeBar', dropTarget, collect)(ColumnHeaderContainer);

exports.default = _default;